import { ContentData } from "../../src/apis/stateful-content";
import { ColumnTypes } from "../../src/components/stateful-content/stateful-table/column-types";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;
import { StatusType } from "@trumpf/ux.ui-widgets/dist/collection/components/status/status-types";

const transactionFailed: StatusType = "SERVICE_CALL_TransactionFailed";
const open: StatusType = "SERVICE_CALL_Open";
const deleted: StatusType = "SERVICE_CALL_Deleted";
const closed: StatusType = "SERVICE_CALL_Closed";
const waitingForCustomer: StatusType = "SERVICE_CALL_WaitingForCustomer";
const inProcess: StatusType = "SERVICE_CALL_InProcess";
const callPredictive: StatusType = "SERVICE_CALL_call-predictive";
const newMessage: StatusType = "SERVICE_CALL_NewTechMessage";

const response: ContentData = {
    totalCount: 31,
    filteredCount: 31,
    labelCount: "Treffer",
    schema: {
        fullMachineName: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        status: {
            type: ColumnTypes.Status,
            sortable: true,
            "primary-mobile": false,
        },
        notificationType: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        sisCaseId: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        createdByUser: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        creationDate: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
    },
    messages: {
        "unreadChatMessagesText": "Neue Nachricht von TRUMPF"
    },
    items: [
    {
      "createdByUser": "",
      "creationDate": "23.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=2c206701-74d2-4cc4-b4f1-e55f3f428162&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=c7ee80d29576153b489f5f10e467c0aacb1d5ab9&cHash=dc0ba8503091fd2bafd110a36878c5b9",
      "fullMachineName": null,
      "lastUpdateFromSis": "28.03.2022",
      "notificationType": "Störung ohne Stillstand",
      "description": "Null machine name - visual test for DEVTWSSERVAPP-1317",
      "sisCaseId": "7104207",
      "unreadChatMessages": 4,
      "status": open
    },
    {
      "createdByUser": "",
      "creationDate": "23.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=2c206701-74d2-4cc4-b4f1-e55f3f428162&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=c7ee80d29576153b489f5f10e467c0aacb1d5ab9&cHash=dc0ba8503091fd2bafd110a36878c5b9",
      "fullMachineName": "TruLaser Tube 5000 T06 fiber - TWDEDEMO070",
      "lastUpdateFromSis": "28.03.2022",
      "notificationType": "Störung ohne Stillstand",
      "description": "Lorem ipsum description",
      "sisCaseId": "7104207",
      "unreadChatMessages": 0,
      "status": open,
    },
    {
      "createdByUser": "maier280510",
      "creationDate": "23.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=bed7e3d9-28d1-4abe-aa52-002fb6d5284e&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=5af27fcb4d0afa93f79c1e4c6dbf7d80e4c56508&cHash=719be33569a1e2e5dfa55b2107e6b874",
      "fullMachineName": "TruLaser Cell 3000 - TWDEDEMO066",
      "lastUpdateFromSis": "28.03.2022",
      "notificationType": "Störung ohne Stillstand",
      "description": "Lorem ipsum 1 description",
      "unreadChatMessages": 0,
      "sisCaseId": "7104205",
      "status": closed
    },
    {
      "createdByUser": "",
      "creationDate": "11.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=7911c0dc-34d8-435b-a3dd-bbfb085c895d&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=9fe6cf0040419fc71e8ac209a60cac3afeb9c0a3&cHash=6c5db671b4289598a920f76418f87865",
      "fullMachineName": "TruLaser Tube 5000 T06 fiber - TWDEDEMO070",
      "lastUpdateFromSis": "11.03.2022",
      "notificationType": "Maschinenstillstand",
      "description": "Salem ipsum description",
      "sisCaseId": "7104076",
      "unreadChatMessages": 0,
      "status": open
    },
    {
      "createdByUser": "",
      "creationDate": "11.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=81acaaa0-2296-4ea2-8374-247caf0f86f7&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=fd818316c72b01a09bbf477ad1afa06237e0257b&cHash=536d09897cd7268691a20af36833bab7",
      "fullMachineName": "TruLaser Tube 5000 T06 fiber - TWDEDEMO070",
      "lastUpdateFromSis": "11.03.2022",
      "notificationType": "Maschinenstillstand",
      "description": "Lorem ipsum",
      "sisCaseId": "7104075",
    "unreadChatMessages": 0,
      "status": waitingForCustomer,
    },
    {
      "createdByUser": "",
      "creationDate": "11.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=59b441fc-f26b-4933-a3ba-6452186eaabf&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=fe78bc8016675b35d9c1e6a6c12d3990703e6c91&cHash=8313d9cb79fde64366ff92a9ed86c693",
      "fullMachineName": "TruLaser Tube 5000 T06 fiber - TWDEDEMO070",
      "lastUpdateFromSis": "11.03.2022",
      "notificationType": "Maschinenstillstand",
      "description": "Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor.",
      "sisCaseId": "7104074",
      "status": inProcess,
    "unreadChatMessages": 0,

    },
    {
      "createdByUser": "",
      "creationDate": "11.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=613eebb1-ad04-4caf-bcf7-85225625a437&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=2c6ed1421a562809124f8651f2b2279e2108149e&cHash=194440888ccb87021ce22b4b9a50610c",
      "fullMachineName": "TruLaser Tube 5000 T06 fiber - TWDEDEMO070",
      "lastUpdateFromSis": "11.03.2022",
      "notificationType": "Maschinenstillstand",
      "description": "Lorem ipsum description",
      "sisCaseId": "7104073",
      "status": callPredictive,
    "unreadChatMessages": 0,
    },
    {
      "createdByUser": "",
      "creationDate": "11.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=8896a3b8-5030-4811-ab3f-44b56cdab7b3&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=846645eaad07b357e9884dd65b034db6272d6801&cHash=ffe17491bafb67417d80d05406f38679",
      "fullMachineName": "TruLaser Tube 5000 T06 fiber - TWDEDEMO070",
      "lastUpdateFromSis": "11.03.2022",
      "notificationType": "Maschinenstillstand",
      "description": "Lorem ipsum description",
      "sisCaseId": "7104072",
      "status": transactionFailed,
      "unreadChatMessages": 1,

    },
    {
      "createdByUser": "",
      "creationDate": "11.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=b210069f-d378-4b04-bb1c-b85441cdf03f&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=1e09ae47c3beee1d13e775fef060a20dbaa54427&cHash=0ff4af664349fc9f2b7c4d7fcf7c017d",
      "fullMachineName": "TruLaser Tube 5000 T06 fiber - TWDEDEMO070",
      "lastUpdateFromSis": "11.03.2022",
      "notificationType": "Maschinenstillstand",
      "description": "Lorem ipsum description",
      "sisCaseId": "7104071",
      "status": deleted,
      "unreadChatMessages": 0,
    },
    {
      "createdByUser": "",
      "creationDate": "11.03.2022",
      "detailLink": "http://trumpf.local.tru/de_DE/mytrumpf/meine-servicefaelle/?tx_mytrumpf_servicecalls%5Baction%5D=serviceCallsDetail&tx_mytrumpf_servicecalls%5BcallId%5D=7566db7e-2f1a-4bdf-9780-77b1b0ea66ac&tx_mytrumpf_servicecalls%5Bcontroller%5D=ServiceCalls&tx_mytrumpf_servicecalls%5Bh%5D=b2ff442de481f5955e333eeed80df2fadc33d07f&cHash=0201d2c631e8576eb989eec55fbf6ef8",
      "fullMachineName": "TruLaser Tube 5000 T06 fiber - TWDEDEMO070",
      "lastUpdateFromSis": "11.03.2022",
      "notificationType": "Maschinenstillstand",
      "description": "Lorem ipsum description Lorem ipsum description",
      "sisCaseId": "7104070",
      "status": newMessage,
      "unreadChatMessages": 0
    }
  ]
};

const emptyResponse: ContentData = {
    totalCount: 0,
    filteredCount: 0,
    labelCount: "Treffer",
    items: [],
    error: {
        head: "Es liegen keine Fälle vor",
    },
};

const writeToFile = (object: ContentData, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "myservicecalls-stateful");
writeToFile(emptyResponse, "myservicecalls-stateful-empty");